// Central content module. Bilingual (DE primary / EN). CMS-like: add projects,
// products and services here without touching the design.
import exlibrisCover from "../assets/covers/exlibris.jpg";
import lumoLightCover from "../assets/covers/lumo_light.jpg";
import lumoAnswerCover from "../assets/covers/lumo_answer.jpg";
import esvanLogo from "../assets/covers/esvan.jpg";

const B = "https://static.prod-images.emergentagent.com/jobs/a0cffeb8-45aa-428a-a51d-c00d17ce097e/images/";
const IMG = {
  hero_website: B + "45a0b2a09c129b4dadecccc3e784baf3e1b0110d1da9be2b60c9ec5fb6a35a6f.jpeg",
  hero_app: B + "566d027d1a4ead2bb0ef3edbd5b1ae830197ffd9adfba0c66cd6d95cc96ae1a2.jpeg",
  hero_books: B + "a38ad4d465e8a84b9726a744f6fc9d98d277a3d6c7cf3635ba6ca2e3331f66cb.jpeg",
  andrea: B + "61946883e4bb765e2f67900e0e697cf236bea1e7aadcc42b748ad600d5a80862.jpeg",
  minijob: B + "d29466aca4b14ccf8cee84c66a386952363771778d7cb4294931a0e9d72866e9.jpeg",
  aicourse: B + "0111d31a65007fa78ed57fa68819396beecf969f7f8b43053add067d266fec46.jpeg",
  willowbrook: B + "8d2b5807eafd9860d2321bad48be907159f894651f858b181a2ca3d6b26f4941.jpeg",
  poetcore: B + "83cf25f0ffcf972a0d0439413187a9daadc313e0fd28ce8c2a0ac06ee2548b91.jpeg",
  darkcottage: B + "4c684abedddee15bf6590dc2f5362377c7620d09441a0e38cb9e833b1e5629d2.jpeg",
  exlibris: exlibrisCover,
  lumo: lumoLightCover,
  lumo_answer: lumoAnswerCover,
  esvan: esvanLogo,
};
export { IMG };

// Brand assets extracted from the WERKVERDUNG brand board.
// PNGs are bundled by Webpack; the video is streamed from the backend so it is
// served with a correct video/* MIME type and byte-range support (static hosts
// serve .mp4 as application/octet-stream, which breaks <video> playback).
import markPng from "../assets/brand/mark.png";
import logomarkPng from "../assets/brand/logomark.png";
import lockupPng from "../assets/brand/lockup.png";

const MEDIA_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/media`;

export const LOGO = {
  mark: markPng, // W + gold arrow (hero)
  badge: logomarkPng, // compact badge (header/nav)
  lockup: lockupPng, // full lockup (loader/hero)
  reveal: `${MEDIA_BASE}/reveal.mp4`, // cinematic intro video (mp4)
  revealWebm: `${MEDIA_BASE}/reveal.webm`, // cinematic intro video (webm)
};

export const BRAND = {
  wordmark: "WERKVERDUNG",
  tagline: { de: "Von der Idee zum fertigen Produkt", en: "From idea to finished product" },
  whatsapp: "4915569082603", // digits incl. country code, no + or spaces
  whatsappDisplay: "+49 15569 082603",
  email: "teodorescuflorian47@gmail.com",
  owner: "Florian Teodorescu",
  address: { street: "Schwabacher Str. 149", city: "90763 Fürth" },
};

// Build a WhatsApp click-to-chat link. Optional prefilled text.
export const whatsappLink = (text = "") =>
  BRAND.whatsapp
    ? `https://wa.me/${BRAND.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ""}`
    : null;

export const CATEGORIES = [
  { id: "all", label: { de: "Alle", en: "All" } },
  { id: "websites", label: { de: "Websites", en: "Websites" } },
  { id: "apps", label: { de: "Apps", en: "Apps" } },
  { id: "books", label: { de: "Bücher", en: "Books" } },
  { id: "digital-products", label: { de: "Digitale Produkte", en: "Digital Products" } },
];

export const PROJECTS = [
  {
    slug: "andrea-aesthetic-heilpraktik",
    title: "Andrea — Aesthetic & Heilpraktik",
    category: "websites",
    image: IMG.andrea,
    year: "2025",
    type: { de: "Website", en: "Website" },
    role: { de: "Strategie, Design, Build", en: "Strategy, design, build" },
    short: {
      de: "Eine ruhige, vertrauensvolle Website für eine Heilpraktikerin und Aesthetik-Praxis.",
      en: "A calm, trustworthy website for an aesthetic and holistic health practice.",
    },
    span: "large",
    overview: {
      de: "Eine editorial gestaltete Website für eine Praxis, die Ästhetik und Heilpraktik verbindet — warm, ruhig und professionell.",
      en: "An editorial website for a practice combining aesthetics and holistic health — warm, calm and professional.",
    },
    problem: {
      de: "Die Praxis brauchte eine Online-Präsenz, die Ruhe und Kompetenz ausstrahlt, statt eines generischen Vorlagen-Looks.",
      en: "The practice needed an online presence that radiates calm and competence, instead of a generic template look.",
    },
    approach: {
      de: "Klare Informationsarchitektur, warme Farbwelt und viel Raum, damit Behandlungen und Vertrauen im Vordergrund stehen.",
      en: "Clear information architecture, a warm palette and generous space so treatments and trust take center stage.",
    },
    built: {
      de: ["Responsive Website", "Behandlungs- & Leistungsseiten", "Kontakt- & Terminanfrage", "SEO-Grundlage"],
      en: ["Responsive website", "Treatment & service pages", "Contact & appointment request", "SEO foundation"],
    },
    tech: ["React", "Tailwind", "Responsive", "SEO"],
    gallery: [IMG.andrea, IMG.hero_website],
    result: {
      de: "Eine Website, die den Charakter der Praxis widerspiegelt und bereit für den Launch ist.",
      en: "A website that reflects the character of the practice and is ready to launch.",
    },
    liveLink: "https://andrea-ästhetik-heilpraktik.com",
  },
  {
    slug: "minijob-ai",
    title: "MiniJob AI",
    category: "apps",
    image: IMG.minijob,
    year: "2025",
    type: { de: "Web- & Mobile-App", en: "Web & mobile app" },
    role: { de: "Konzept, Produkt, Build", en: "Concept, product, build" },
    short: {
      de: "Eine App, die Minijob-Suchende und Angebote mit KI-Unterstützung zusammenbringt.",
      en: "An app that connects mini-job seekers and openings with AI assistance.",
    },
    span: "medium",
    overview: {
      de: "Ein Produktkonzept für eine schlanke App im Bereich flexibler Arbeit — vom Konzept bis zum nutzbaren Produkt.",
      en: "A product concept for a lean app in the flexible-work space — from concept to a usable product.",
    },
    problem: {
      de: "Der Prozess, passende Minijobs zu finden und zu bewerben, ist umständlich und unübersichtlich.",
      en: "Finding and applying to the right mini-jobs is clunky and hard to navigate.",
    },
    approach: {
      de: "Ein klarer, kartenbasierter Flow mit KI-gestütztem Matching im Hintergrund — sichtbar bleibt das Ergebnis, nicht das Werkzeug.",
      en: "A clear, card-based flow with AI-assisted matching in the background — the result stays visible, not the tooling.",
    },
    built: {
      de: ["App-Interface", "Matching-Flow", "Profil & Bewerbung", "KI-gestützte Vorschläge"],
      en: ["App interface", "Matching flow", "Profile & application", "AI-assisted suggestions"],
    },
    tech: ["React", "Mobile-first", "AI-assisted"],
    gallery: [IMG.minijob, IMG.hero_app],
    result: {
      de: "Ein durchdachtes, nutzbares Produkt-Interface, bereit für die nächste Ausbaustufe.",
      en: "A considered, usable product interface, ready for the next build stage.",
    },
    liveLink: "https://minijobai.com",
  },
  {
    slug: "ai-from-zero-to-pro",
    title: "AI From Zero to Pro",
    category: "digital-products",
    image: IMG.aicourse,
    year: "2025",
    type: { de: "Online-Kurs", en: "Online course" },
    role: { de: "Konzept, Design, Aufbau", en: "Concept, design, build" },
    short: {
      de: "Ein strukturierter Kurs, der Einsteiger zu selbstsicherer KI-Nutzung führt.",
      en: "A structured course taking beginners to confident, practical AI use.",
    },
    span: "medium",
    overview: {
      de: "Ein digitales Produkt: ein Kurs mit klarer Lernstruktur und sauberem, ruhigem Interface.",
      en: "A digital product: a course with a clear learning structure and a clean, calm interface.",
    },
    problem: {
      de: "KI-Wissen ist verstreut und überfordernd — es fehlt ein klarer, geführter Weg.",
      en: "AI knowledge is scattered and overwhelming — a clear, guided path is missing.",
    },
    approach: {
      de: "Modularer Aufbau, verständliche Sprache und eine Oberfläche, die das Lernen in den Mittelpunkt stellt.",
      en: "Modular structure, plain language and an interface that keeps learning at the center.",
    },
    built: {
      de: ["Kursstruktur", "Lektions-Interface", "Fortschritts-Logik", "Verkaufsseite"],
      en: ["Course structure", "Lesson interface", "Progress logic", "Sales page"],
    },
    tech: ["Curriculum", "UI Design", "Publishing"],
    gallery: [IMG.aicourse],
    result: {
      de: "Ein launch-fähiges Kursprodukt mit klarer Struktur.",
      en: "A launch-ready course product with a clear structure.",
    },
    liveLink: "https://teodorescu3.gumroad.com/l/ai-from-zero-pro",
  },
  {
    slug: "willowbrook-series",
    title: "Willowbrook Series",
    category: "books",
    image: IMG.willowbrook,
    year: "2024",
    type: { de: "Buchreihe", en: "Book series" },
    role: { de: "Konzept, Cover, Publishing", en: "Concept, covers, publishing" },
    short: {
      de: "Eine literarische Reihe mit zusammenhängender, ruhiger Cover-Sprache.",
      en: "A literary series with a coherent, quiet cover language.",
    },
    span: "medium",
    overview: {
      de: "Eine Buchreihe, konzipiert und gestaltet für eine stimmige, wiedererkennbare Identität über alle Bände hinweg.",
      en: "A book series conceived and designed for a coherent, recognizable identity across every volume.",
    },
    problem: {
      de: "Eine Reihe braucht Wiedererkennbarkeit, ohne dass die einzelnen Bände beliebig wirken.",
      en: "A series needs recognizability without the individual volumes feeling interchangeable.",
    },
    approach: {
      de: "Ein festes Gestaltungssystem aus Typografie, botanischen Linien und einem warmen Farbcode.",
      en: "A fixed design system of typography, botanical line-art and a warm color code.",
    },
    built: {
      de: ["Cover-System", "Innenlayout", "KDP-Vorbereitung"],
      en: ["Cover system", "Interior layout", "KDP preparation"],
    },
    tech: ["Publishing", "Amazon KDP", "Cover Design"],
    gallery: [IMG.willowbrook, IMG.hero_books],
    result: {
      de: "Eine wiedererkennbare Reihe, bereit für die Veröffentlichung.",
      en: "A recognizable series, ready to publish.",
    },
    liveLink: "https://a.co/d/0aK9Gx0P",
  },
  {
    slug: "poetcore",
    title: "Poetcore",
    category: "books",
    image: IMG.poetcore,
    year: "2024",
    type: { de: "Lyrik-Kollektion", en: "Poetry collection" },
    role: { de: "Konzept, Design, Publishing", en: "Concept, design, publishing" },
    short: {
      de: "Eine zeitgenössische Lyrik-Reihe mit typografisch geprägten Covern.",
      en: "A contemporary poetry line with typographic, art-house covers.",
    },
    span: "medium",
    overview: {
      de: "Eine Lyrik-Kollektion mit einer eigenständigen, typografischen Bildsprache.",
      en: "A poetry collection with a distinct, typographic visual language.",
    },
    problem: {
      de: "Lyrik braucht Cover, die Haltung zeigen, statt austauschbarer Stockmotive.",
      en: "Poetry needs covers with a point of view, not interchangeable stock imagery.",
    },
    approach: {
      de: "Reduktion auf Typografie, Kontrast und viel Weißraum.",
      en: "Reduction to typography, contrast and generous white space.",
    },
    built: {
      de: ["Cover-Design", "Typografie-System", "KDP-Vorbereitung"],
      en: ["Cover design", "Typography system", "KDP preparation"],
    },
    tech: ["Publishing", "Typography", "Amazon KDP"],
    gallery: [IMG.poetcore],
    result: {
      de: "Eine eigenständige Reihe mit klarer Handschrift.",
      en: "A distinct line with a clear signature.",
    },
    liveLink: "https://a.co/d/08SoTtHh",
  },
  {
    slug: "dark-cottagecore-series",
    title: "Dark Cottagecore Series",
    category: "books",
    image: IMG.darkcottage,
    year: "2024",
    type: { de: "Buchreihe", en: "Book series" },
    role: { de: "Konzept, Cover, Publishing", en: "Concept, covers, publishing" },
    short: {
      de: "Eine atmosphärische Reihe mit dunkler, romantischer Bildwelt.",
      en: "An atmospheric series with a dark, romantic visual world.",
    },
    span: "large",
    overview: {
      de: "Eine Buchreihe mit einer klaren, stimmungsvollen Ästhetik zwischen Dunkelheit und Wärme.",
      en: "A book series with a clear, moody aesthetic balanced between darkness and warmth.",
    },
    problem: {
      de: "Das Genre lebt von Atmosphäre — die Cover müssen diese sofort transportieren.",
      en: "The genre lives on atmosphere — the covers must convey it instantly.",
    },
    approach: {
      de: "Tiefe Farben, Chiaroscuro-Licht und ein konsistentes Reihen-System.",
      en: "Deep colors, chiaroscuro lighting and a consistent series system.",
    },
    built: {
      de: ["Cover-System", "Reihen-Identität", "KDP-Vorbereitung"],
      en: ["Cover system", "Series identity", "KDP preparation"],
    },
    tech: ["Publishing", "Cover Design", "Amazon KDP"],
    gallery: [IMG.darkcottage],
    result: {
      de: "Eine atmosphärisch stimmige Reihe, bereit für den Launch.",
      en: "An atmospherically coherent series, ready to launch.",
    },
    liveLink: "https://a.co/d/03cyOePe",
  },
];

export const WHAT_I_BUILD = [
  {
    id: "websites",
    title: "Websites",
    desc: {
      de: "Premium-Websites für Unternehmen, Selbstständige und Marken.",
      en: "Premium websites built for businesses, professionals and brands.",
    },
    image: IMG.hero_website,
  },
  {
    id: "apps",
    title: "Apps",
    desc: {
      de: "Web- und Mobile-Anwendungen — vom Konzept zum nutzbaren Produkt.",
      en: "Web and mobile applications, from concept to usable product.",
    },
    image: IMG.hero_app,
  },
  {
    id: "publishing",
    title: "Publishing",
    desc: {
      de: "Bücher, digitale Publikationen und Amazon-KDP-fertige Projekte.",
      en: "Books, digital publications and Amazon KDP-ready projects.",
    },
    image: IMG.hero_books,
  },
  {
    id: "digital-products",
    title: "Digital Products",
    desc: {
      de: "Kurse, KI-gestützte Tools, Downloads und launch-fertige digitale Assets.",
      en: "Courses, AI-powered tools, downloadable products and launch-ready digital assets.",
    },
    image: IMG.aicourse,
  },
];

export const PROCESS = [
  { n: "01", title: { de: "Idee", en: "Idea" }, desc: { de: "Das Konzept klären.", en: "Clarify the concept." } },
  { n: "02", title: { de: "Strategie", en: "Strategy" }, desc: { de: "Definieren, was gebaut werden muss.", en: "Define what needs to be built." } },
  { n: "03", title: { de: "Build", en: "Build" }, desc: { de: "Das Produkt gestalten und entwickeln.", en: "Design and develop the product." } },
  { n: "04", title: { de: "Refine", en: "Refine" }, desc: { de: "Testen, verbessern, verfeinern.", en: "Test, improve and polish." } },
  { n: "05", title: { de: "Launch", en: "Launch" }, desc: { de: "Deployen, veröffentlichen, releasen.", en: "Deploy, publish or release." } },
];

export const ADVANTAGES = [
  { de: "Eine Person, ein Workflow", en: "One person, one workflow" },
  { de: "Schnelle Iteration", en: "Fast iteration" },
  { de: "Hohe visuelle Standards", en: "Strong visual standards" },
  { de: "KI-gestützte Effizienz", en: "AI-assisted efficiency" },
  { de: "Vollständiges Produktdenken", en: "Full product thinking" },
  { de: "Launch-orientierte Umsetzung", en: "Launch-oriented execution" },
];

export const SERVICES = [
  {
    id: "website-creation",
    title: { de: "Website Creation", en: "Website Creation" },
    build: {
      de: "Premium-Websites — von Struktur und Design bis zur fertigen, launch-bereiten Seite.",
      en: "Premium websites — from structure and design to a finished, launch-ready site.",
    },
    who: {
      de: "Für Unternehmen, Selbstständige und Marken, die auftreten wollen wie ein Studio.",
      en: "For businesses, professionals and brands that want to show up like a studio.",
    },
    deliver: {
      de: ["Responsive Design & Build", "Klare Informationsarchitektur", "SEO-Grundlage", "Launch-Vorbereitung"],
      en: ["Responsive design & build", "Clear information architecture", "SEO foundation", "Launch preparation"],
    },
    image: IMG.hero_website,
  },
  {
    id: "app-development",
    title: { de: "App Development", en: "App Development" },
    build: {
      de: "Web- und Mobile-Apps — vom Konzept über das Interface bis zum nutzbaren Produkt.",
      en: "Web and mobile apps — from concept and interface to a usable product.",
    },
    who: {
      de: "Für alle mit einer Produktidee, die real und benutzbar werden soll.",
      en: "For anyone with a product idea that needs to become real and usable.",
    },
    deliver: {
      de: ["Produktkonzept", "UI/UX-Design", "Funktionsfähiger Build", "KI-gestützte Effizienz"],
      en: ["Product concept", "UI/UX design", "Working build", "AI-assisted efficiency"],
    },
    image: IMG.hero_app,
  },
  {
    id: "digital-products",
    title: { de: "Digital Product Development", en: "Digital Product Development" },
    build: {
      de: "Kurse, KI-Tools und downloadbare Produkte — konzipiert, gebaut und startklar.",
      en: "Courses, AI tools and downloadable products — designed, built and ready to ship.",
    },
    who: {
      de: "Für Creator und Fachleute, die ihr Wissen als Produkt verkaufen wollen.",
      en: "For creators and professionals who want to sell their knowledge as a product.",
    },
    deliver: {
      de: ["Produktstruktur", "Interface & Design", "Verkaufsseite", "Launch-fähige Assets"],
      en: ["Product structure", "Interface & design", "Sales page", "Launch-ready assets"],
    },
    image: IMG.aicourse,
  },
  {
    id: "book-kdp",
    title: { de: "Book & KDP Projects", en: "Book & KDP Projects" },
    build: {
      de: "Bücher und Reihen — Cover, Layout und Amazon-KDP-fertige Dateien.",
      en: "Books and series — covers, layout and Amazon-KDP-ready files.",
    },
    who: {
      de: "Für Autor:innen und Publisher, die professionell veröffentlichen wollen.",
      en: "For authors and publishers who want to publish professionally.",
    },
    deliver: {
      de: ["Cover-Design", "Innenlayout", "KDP-fertige Dateien", "Reihen-System"],
      en: ["Cover design", "Interior layout", "KDP-ready files", "Series system"],
    },
    image: IMG.hero_books,
  },
];

// Own products (separate from client services), with real store links.
export const PRODUCT_CATEGORIES = [
  { id: "all", label: { de: "Alle", en: "All" } },
  { id: "coloring", label: { de: "Ausmalbücher", en: "Coloring books" } },
  { id: "poetry", label: { de: "Lyrik", en: "Poetry" } },
  { id: "novels", label: { de: "Romane", en: "Novels" } },
  { id: "courses", label: { de: "Kurse", en: "Courses" } },
  { id: "ki-tools", label: { de: "KI-Tools", en: "KI-Tools" } },
];

export const PRODUCTS = [
  {
    id: "willowbrook",
    category: "coloring",
    title: "Cozy Little Town — Willowbrook",
    image: IMG.willowbrook,
    platform: "Amazon KDP",
    desc: { de: "Gemütliche Ausmalbuch-Reihe rund um die Kleinstadt Willowbrook.", en: "Cozy coloring-book series set in the little town of Willowbrook." },
    volumes: [
      { label: "Vol. 1 — A Cozy Little Town", link: "https://a.co/d/0aK9Gx0P" },
      { label: "Vol. 2 — A Weekend in Willowbrook", link: "https://a.co/d/0hbHiXtZ" },
      { label: "Vol. 3 — Autumn in Willowbrook", link: "https://a.co/d/0hvVqDiw" },
      { label: "Halloween — Warm Pumpkin Nights", link: "https://a.co/d/02CYCaSO" },
    ],
  },
  {
    id: "poetcore",
    category: "poetry",
    title: "Poetcore",
    image: IMG.poetcore,
    platform: "Amazon KDP",
    desc: { de: "Zeitgenössische Lyrik-Kollektion mit typografischen Covern.", en: "Contemporary poetry collection with typographic covers." },
    volumes: [
      { label: "Rainy Days Vol. 1 — Forgotten Letters", link: "https://a.co/d/08SoTtHh" },
      { label: "Christmas Vol. 2 — Letters by Candlelight", link: "https://a.co/d/0cPTpHQx" },
    ],
  },
  {
    id: "dark-cottagecore",
    category: "coloring",
    title: "Dark Cottagecore",
    image: IMG.darkcottage,
    platform: "Amazon KDP",
    desc: { de: "Atmosphärische Ausmalreihe mit dunkler, romantischer Bildwelt.", en: "Atmospheric coloring series with a dark, romantic visual world." },
    volumes: [
      { label: "Vol. 1 — The Witch's Kitchen", link: "https://a.co/d/03cyOePe" },
      { label: "Vol. 2 — Moonlit Cottage", link: "https://a.co/d/0aOBRMhb" },
      { label: "Cottagegore Vol. 1 — Cozy Nightmares", link: "https://a.co/d/0cu2DI1T" },
    ],
  },
  {
    id: "exlibris",
    category: "coloring",
    title: "Ex Libris — Dark Academia",
    image: IMG.exlibris,
    platform: "Amazon KDP",
    desc: { de: "Ein Dark-Academia-Ausmalbuch — Kerzenschein, Bücher und Atmosphäre.", en: "A dark academia coloring book — candlelight, books and atmosphere." },
    volumes: [
      { label: "Vol. 1 — A Dark Academia Coloring Book", link: "https://a.co/d/07TZuOc6" },
    ],
  },
  {
    id: "lumo",
    category: "novels",
    title: "The LUMO Universe",
    image: IMG.lumo,
    platform: "Amazon",
    desc: { de: "Eine atmosphärische Roman-Reihe aus dem LUMO-Universum.", en: "An atmospheric novel series from the LUMO universe." },
    volumes: [
      { label: "The Light Remembers — Book Two", link: "https://a.co/d/0gKsETxA", cover: lumoLightCover },
      { label: "The Answer Beside You", link: "https://a.co/d/0gx2gMMK", cover: lumoAnswerCover },
    ],
  },
  {
    id: "ai-from-zero",
    category: "courses",
    title: "AI From Zero to Pro",
    image: IMG.aicourse,
    platform: "Course / Gumroad",
    desc: { de: "Strukturierter Kurs für selbstsichere, praktische KI-Nutzung.", en: "Structured course for confident, practical AI use." },
    cta: "buy",
    link: "https://teodorescu3.gumroad.com/l/ai-from-zero-pro",
  },
  {
    id: "minijob-ai",
    category: "ki-tools",
    title: "MiniJob AI",
    image: IMG.minijob,
    platform: "Web / Google Play",
    desc: { de: "App, die Minijob-Suchende und Angebote mit KI zusammenbringt.", en: "App connecting mini-job seekers and openings with AI." },
    cta: "view",
    link: "https://minijobai.com",
  },
  {
    id: "esvan",
    category: "ki-tools",
    title: "ESVAN",
    image: IMG.esvan,
    platform: "Web-App",
    desc: {
      de: "Keine Angst mehr vor dem Briefkasten. www.esvan.de",
      en: "Keine Angst mehr vor dem Briefkasten. www.esvan.de",
    },
    cta: "view",
    link: "https://www.esvan.de",
  },
];

